import React from 'react';
import { TopHeader } from 'components';
import {
  selectSupportReqSubmitting,
  selectSupportRes
} from 'redux/user/selector';
import { useSelector } from 'react-redux';
import SupportReqSuccess from 'components/contactSupportModal/supportReqSuccess';
// Temporary block - need to delete after Helix enabled
import RemedyForceSupportReqSuccess from 'components/remedyForceModal/supportReqSuccess';
// Temporary block
export interface PageProps {
  enableHeaderGlobalBar?: boolean;
}

/**
 * FULL HEADER, LEFT AND RIGHT PANEL LAYOUT (3 COLUMN)
 */
export const UnAuthenticatedPageLayout: React.FC<PageProps> = (props: any) => {
  const supportRes: any = useSelector(selectSupportRes);
  const submitting: boolean = useSelector(selectSupportReqSubmitting);

  return props.children ? (
    <React.Fragment>
      <TopHeader enableHeaderGlobalBar={false} showBurgerMenuButton={false} />
      {props.children}
      {!submitting && supportRes ? (
        <>
          {process.env.REACT_APP_REMEDY_FORCE_ENABLED === 'true' ? (
            <RemedyForceSupportReqSuccess />
          ) : (
            <SupportReqSuccess />
          )}
        </>
      ) : null}
    </React.Fragment>
  ) : null;
};
